export const ANALYSIS_MEAN_SIZE_FIELD_LEVEL = 'analysis-mean_size';
export const ANALYSIS_MEAN_SIZE_ZONE_LEVEL = 'analysis-mean_size_zone_level';
export const ANALYSIS_PLANT_POPULATION_FIELD_LEVEL =
  'analysis-plant_population';
export const ANALYSIS_PLANT_POPULATION_ZONE_LEVEL =
  'analysis-plant_population_zone_level';
export const ANALYSIS_PHOTOGRAPHIC_IMAGERY = 'analysis-photographic_imagery';
export const ANALYSIS_GRIDDED_NDVI = 'analysis-gridded_ndvi';
